/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');

var GetAnnualMeeting = require('../services/GetAnnualMeeting');
var DepAnnualMeetingEditView = require('../views/DepAnnualMeetingEditView');

module.exports = function(entityId, annualMeetingId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetEntityIdentifiers(entityId), GetAnnualMeeting(annualMeetingId))
    .done(function(entityIdentifiers, annualMeeting) {
      NavUtils.navigate('dep/entity/' + entityId + '/governance/' + annualMeetingId + '/edit');
      Scaffold.content.show(
        new DepAnnualMeetingEditView({
          model: new Backbone.Model({
            entityIdentifiers: entityIdentifiers,
            annualMeeting: annualMeeting
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
